import {
  RtFraction,
  RtWithName,
  RtWithProjectionPeriods,
  RtWithRelativesSet,
} from "@aprao/common/src/runtypes/common.js";
import { z } from "zod";

import { WithTimelineOverrideSchema } from "./TimelineStageSchema.js";

export const RtSiteUseClass = z.enum([
  "Residential",
  "NonResidential",
  "Residential.2022-09-23",
  "Residential.2025-04-01",
]);
export const RtLandTaxCalculationType = z.enum(["auto", "manual"]);

export const RtPriceCalculationType = z.enum(["residual", "manual"]);

export const RtCustomCostKeys = z.enum(["absolute", "ratioPrice"]);

export const RtLandTax = z
  .object({
    useClassCurrent: RtSiteUseClass,
    calculationType: RtLandTaxCalculationType,
    // when calculation type is "manual"
    definedAmount: RtWithRelativesSet(z.enum(["absolute", "ratioPrice"])),
    // when calculation type is "auto"
    surcharge: RtFraction.nullable(),
  })
  .merge(RtWithProjectionPeriods)
  .merge(WithTimelineOverrideSchema);

export const RtPricePurchase = z
  .object({
    calculationType: RtPriceCalculationType,
    definedAmount: RtFraction.nullable(),
  })
  .merge(RtWithProjectionPeriods)
  .merge(WithTimelineOverrideSchema);

export const RtCustomCost = RtWithRelativesSet(RtCustomCostKeys)
  .merge(RtWithName)
  .merge(RtWithProjectionPeriods)
  .merge(WithTimelineOverrideSchema);

export const RtSitePurchase = z.object({
  description: z.string(),
  landTax: RtLandTax,
  pricePurchase: RtPricePurchase,
  customCosts: z.array(RtCustomCost),
});
